import {find, get, memoize} from 'lodash';
import {IGlobalStore, ITriviaLadder} from "modules/types";
import {EnumTriviaLadders} from "modules/utils/enums";
import {createSelector} from 'reselect';

type TStore = IGlobalStore;

export const getLadder = (state: TStore): TStore["trivia_ladders"] => state.trivia_ladders;

export const isLadderRequested = createSelector(
	[getLadder],
	(ladder) => ladder.is_data_requested
);

export const getPodiumSelector = createSelector(
	[getLadder],
	(ladder) => memoize((ladder_type: EnumTriviaLadders): ITriviaLadder[] => {
		return ladder.ladders[ ladder_type ].podium
	})
);


export const getTriviaContestLadder = createSelector(
	[getLadder],
	(state) => {
		return state.ladders[EnumTriviaLadders.contest]
	}
);

export const getTriviaContestUserRound = createSelector(
	[getTriviaContestLadder],
	(state) => (user_id: number, round_number: number) => {
		const user_ladder = find(state.items, {user_id});
		return get(user_ladder, `rounds[${round_number - 1}]`);
	}
);

export const getTriviaContestTeamLadder = createSelector(
	[getLadder],
	(state) => {
		return state.ladders[ EnumTriviaLadders.team_contest ]
	}
);

export const getTriviaContestTeamUserRound = createSelector(
	[getTriviaContestTeamLadder],
	(state) => (team_id: number = 0, round_number: number) => {
		const user_ladder = find(state.items, {team_id});
		return get(user_ladder, `rounds[${round_number - 1}]`);
	}
);

export const getMonthLadder = createSelector(
	[getLadder],
	(state) => {
		return state.ladders[ EnumTriviaLadders.month ]
	}
);

export const getIsShowLadderModal = createSelector(
	[getLadder],
	({is_show_ladder_modal}) => is_show_ladder_modal
)